import React from "react";
import { ShieldLock } from "react-bootstrap-icons";
import { useNavigate } from "react-router-dom";
import Button from "@components/atoms/Button";

const NotAuthorized = () => {
  const navigate = useNavigate();

  return (
    <div className="flex items-center justify-center min-h-screen bg-gray-50">
      <div className="flex flex-col items-center text-center px-4 max-w-xl">
        <ShieldLock size={56} className="text-primary-600" />
        <p className="font-semibold mt-8 mb-8 px-4">
          You do not have access to the page you have tried to reach.
        </p>
        <Button color="secondary" onClick={() => navigate("/")}>
          Back to Ontik Portal
        </Button>
      </div>
    </div>
  );
};

export default NotAuthorized;
